"use client";

import { META_APP_ID } from "@/constants/metaKeys";
import useExternalSDK from "@/hooks/useExternalSDK";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Spinner from "./ui/Spinner";

export default function MetaSignInAndUp({
  buttonText,
  callback,
  loading = false,
}) {
  const sdkReady = useExternalSDK(
    () => !!window.FB,
    () => {
      window.FB.init({
        appId: META_APP_ID,
        cookie: true,
        xfbml: false,
        version: "v19.0",
      });
    },
  );

  const handleMetaSignIn = () => {
    if (!window.FB) {
      // console.error("Meta SDK yüklenmedi");
      return;
    }

    window.FB.login(
      function (response) {
        if (response.authResponse) {
          const { accessToken, id } = response.authResponse;

          window.FB.api(
            "/me",
            { fields: "id,name,email,picture,first_name,last_name" },
            function (userInfo) {
              callback({
                token: accessToken,
                id: userInfo.id,
                email: userInfo.email,
                name: userInfo.name,
                firstName: userInfo.first_name,
                lastName: userInfo.last_name,
                avatar: userInfo.picture?.data?.url,
              });
            },
          );
        } else {
        }
      },
      { scope: "public_profile,email" },
    );
  };

  return (
    <button
      onClick={handleMetaSignIn}
      type="button"
      disabled={loading || !sdkReady}
      className="text-foreground border-primary-weak flex w-full cursor-pointer items-center justify-center gap-2 rounded-xl border bg-white p-3 disabled:cursor-not-allowed disabled:opacity-50"
    >
      <FontAwesomeIcon
        icon={byPrefixAndName.fak["facebook"]}
        className="text-2xl text-[#0866ff]"
      />

      <span className="font-medium">{buttonText}</span>
      {(loading || !sdkReady) && (
        <Spinner className="text-primary h-4 w-4 animate-spin" />
      )}
    </button>
  );
}
